// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"87fdd582","455":"6e6305be","977":"6d1543f3"}[chunkId] + ".chunk.js";
};